import { useState } from 'react';
export default function useChatLog() {
    const [chatLog, setChatLog] = useState([]);
    const [chatVisible, setChatVisible] = useState(false);
    const [unreadMsgCount, setUnreadMsgCount] = useState(0);
    /**
     * Utility function to handle updating the chat log as well as track unread messages
     * @param msg BeaconChatData
     */
    const addChatMsg = (msg) => {
        setChatLog(p => [...p, msg]);
        !chatVisible && setUnreadMsgCount(p => ++p);
    };
    /**
     * Utility function to toggle chat visibility and reset message count
     */
    const toggleChatVis = () => {
        setUnreadMsgCount(0);
        setChatVisible(p => !p);
    };
    return {
        chatLog,
        addChatMsg,
        chatVisible,
        setChatVisible,
        toggleChatVis,
        unreadMsgCount,
        setUnreadMsgCount,
    };
}
//# sourceMappingURL=useChatLog.js.map